import React from 'react';
import { Link, useParams } from 'react-router-dom';
import { HashLink } from 'react-router-hash-link';

export class SiteSearch extends React.Component {
  constructor(props) {
    super();
    const { match: { params } } = props;
    this.state = {
      keywords: params.keywords,
      page_data: null,
      host: window.location.origin + process.env.REACT_APP_BASE_NAME
    };

  }

  getSearch(keywords) {

    fetch(process.env.REACT_APP_API_URL + '/Search', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json; charset=utf-8',
        'access-control-allow-origin': '*',
        'Authorization': process.env.REACT_APP_AUTHORIZATION_KEY
      },
      body: JSON.stringify({ "keyword": keywords })
    })
      .then(res => res.json())
      .then((data) => {
        if (data.isSuccess) {
          this.setState({ page_data: data });
        }
      })
      .catch((error) => {
        console.error('Error:', error);
      })
  }

  componentDidMount() {
    // var cur_location = window.location.pathname;
    // cur_location = cur_location.substring(cur_location.lastIndexOf('/') + 1);
    // this.getSearch(cur_location);
    this.getSearch(this.state.keywords);
  }

  render() {
    return (
      <section id="SiteSearch">
        <div className="container-fluid content-wrapper position-relative section-1">
          <div className="container">
            <div className="row ">
              <div className="col-md-12 banner-box w-100">
                <div className="box text-center">
                </div>
              </div>
            </div>
          </div>
          <div className="position-absolute bg-flush w-100 h-100 top-0 left-0 pt-5 d-flex align-items-center justify-content-start">
            <div className="container">
              <div className="row ">
                <div className="col-md-12">
                  <p className="text-light d-flex align-items-center">Home <span className="material-icons">chevron_right</span> Search <span className="material-icons">chevron_right</span></p>
                  <h1 className="theme-font-color font-weight-bold m-0">Search</h1>
                </div>
              </div>
            </div>
          </div>
          <div className="position-absolute" style={{ right: 15, bottom: 10 }}>
            <small className="text-light"><i>*Photo was taken before COVID-19</i></small>
          </div>
        </div>
        <div className="container-fluid">
          <div className="container">
            <div className="row">
              <div className="col-md-12 mt-5">
                <h2 className="font-weight-bold">Search Results Of "<span className="font-weight-bold">{this.state.keywords ? this.state.keywords : ""}</span>"</h2>
              </div>
              <div className="col-md-12 mt-3 mb-5">
                {!this.state.page_data && <div>No result!</div>}
                <ul className="list-unstyled">
                  {this.state.page_data && this.state.page_data.results.map((data, index) => {
                    return (
                      <li key={index} className="pb-4">
                        <div className="card">
                          <div className="card-body">
                            <h3><a href={this.state.host + data.pageTitle.replaceAll("<br/>", "").replaceAll(" ", "")} className="theme-sub-color">{data.pageTitle}</a></h3>
                            {/* <p className="m-0 text-wrap"><a href={this.state.host + (data.pageTitle.replaceAll("<br/>", "").replaceAll(" ", "") === "Home" ? '' : data.pageTitle.replaceAll("<br/>", "").replaceAll(" ", ""))}>{this.state.host + data.pageTitle.replaceAll("<br/>", "").replaceAll(" ", "")}</a></p> */}
                            {/* <p className="m-0">Search Results: {data.search.length}</p> */}
                            {data.pageTitle && data.pageTitle.replaceAll("<br/>", "").replaceAll(" ", "") !== 'FAQs' && <ul className="m-0 pl-3">
                              {data.search.map((child, child_index) => {
                                return (
                                  <li key={child_index} className="pt-2 text-ccc text-wrap"><HashLink scroll={(el) => el.scrollIntoView({ behavior: 'auto', block: 'center' })} to={`/${data.pageTitle.replaceAll("<br/>", "").replaceAll(" ", "") === "Home" ? '' : data.pageTitle.replaceAll("<br/>", "").replaceAll(" ", "")}${'#' + child.link}`}>{child.moduleTitle}</HashLink></li>
                                )
                              })
                              }
                            </ul>}
                            {data.pageTitle && data.pageTitle.replaceAll("<br/>", "").replaceAll(" ", "") === 'FAQs' && <ul className="m-0 pl-3">
                              {data.search.map((child, child_index) => {
                                return (
                                  <li key={child_index} className="pt-2 text-ccc text-wrap"><HashLink scroll={(el) => el.scrollIntoView({ behavior: 'auto', block: 'center' })} to={`/${data.pageTitle.replaceAll("<br/>", "").replaceAll(" ", "") === "Home" ? '' : data.pageTitle.replaceAll("<br/>", "").replaceAll(" ", "")}${'#FAQ' + child.link}`}>{child.moduleTitle}</HashLink></li>
                                )
                              })
                              }
                            </ul>}
                          </div>
                        </div>
                      </li>
                    )
                  })
                  }
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }
}

